const PREFIX = 'SNACKBAR_';

export const SNACKBAR_ACTIONS = {
  SET_MESSAGE: `${PREFIX}SET_MESSAGE`,
  SHOW: `${PREFIX}SHOW`,
};

export const snackbarReducer = (state, action) => {
  switch (action.type) {
    case SNACKBAR_ACTIONS.SET_MESSAGE:
      return {
        ...state,
        message: action.message,
      };
    case SNACKBAR_ACTIONS.SHOW:
      return {
        ...state,
        open: action.open,
      };
    default:
      return state;
  }
};
